import {
    strollersAddQuestionUrl,
    strollersAddReviewScoreUrl,
    strollersAddReviewUrl,
    strollersBrandsUrl,
    strollersChartsUrl,
    strollersDetailUrl,
    strollersListUrl,
    strollersPhotoUrl,
    strollersReviewsUrl,
    strollersSearchUrl,
    strollersUrl,
    strollersWikiUrl,
    strollersWishlistUrl,
} from 'mk2/apps/strollers/urls';
import { Route } from 'mk2/containers/Application/Application';

export const routes: Route[] = [{
    app: 'strollers',
    exact: true,
    path: strollersUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/Home/HomePage' /* webpackChunkName: "strollers.Home" */);
    },
    modules: [
        'mk2/apps/strollers/containers/Home/HomePage',
    ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersBrandsUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/Brands/BrandsPage' /* webpackChunkName: "strollers.Brands" */);
    },
    modules: [
        'mk2/apps/strollers/containers/Brands/BrandsPage',
    ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersSearchUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/StrollersSearch/StrollersSearchPage' /* webpackChunkName: "strollers.StrollersSearch" */);
    },
    modules: [ 'mk2/apps/strollers/containers/StrollersSearch/StrollersSearchPage' ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersWishlistUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/Wishlist/WishlistPage' /* webpackChunkName: "strollers.WishList" */);
    },
    modules: [ 'mk2/apps/strollers/containers/WishList/WishListPage' ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersChartsUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/Charts/ChartsPage' /* webpackChunkName: "strollers.Charts" */);
    },
    modules: [ 'mk2/apps/strollers/containers/Charts/ChartsPage' ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersListUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/BrandsStrollersList/BrandsStrollersListPage' /* webpackChunkName: "strollers.BrandsStrollersList" */);
    },
    modules: [
        'mk2/apps/strollers/containers/BrandsStrollersList/BrandsStrollersListPage',
    ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersAddReviewUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/StrollerAddReview/StrollerAddReviewPage' /* webpackChunkName: "strollers.StrollerAddReview" */);
    },
    modules: [ 'mk2/apps/strollers/containers/StrollerAddReview/StrollerAddReviewPage' ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersAddReviewScoreUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/StrollerAddReview/StrollerAddReviewPage' /* webpackChunkName: "strollers.StrollerAddReview" */);
    },
    modules: [ 'mk2/apps/strollers/containers/StrollerAddReview/StrollerAddReviewPage' ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersReviewsUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/StrollerReviews/StrollerReviewsPage' /* webpackChunkName: "strollers.StrollerReviews" */);
    },
    modules: [ 'mk2/apps/strollers/containers/StrollerReviews/StrollerReviewsPage' ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersAddQuestionUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/StrollerAddQuestion/StrollerAddQuestionPage' /* webpackChunkName: "strollers.StrollerAddQuestion" */);
    },
    modules: [ 'mk2/apps/strollers/containers/StrollerAddQuestion/StrollerAddQuestionPage' ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersPhotoUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/StrollerPhoto/StrollerPhotoPage' /* webpackChunkName: "strollers.StrollerPhoto" */);
    },
    modules: [
        'mk2/apps/strollers/containers/StrollerPhoto/StrollerPhotoPage',
    ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersWikiUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/WikiArticle/WikiArticlePage' /* webpackChunkName: "strollers.WikiArticle" */);
    },
    modules: [
        'mk2/apps/strollers/containers/WikiArticle/WikiArticlePage',
    ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersDetailUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/StrollersDetail/StrollersDetailPage' /* webpackChunkName: "strollers.StrollersDetail" */);
    },
    modules: [
        'mk2/apps/strollers/containers/StrollersDetail/StrollersDetailPage',
    ],
}];
